/** Clamps an item count to Sparky `Grid`'s 1-3 column literal union — `Grid.columns` only accepts the
 * closed `ColumnNumber` type, not a plain `number`, so a runtime-computed count needs asserting back
 * into it. Clamped rather than passed through raw: a `Grid` past 3 columns gets cramped on desktop for
 * these card-style blocks. */
export const gridColumns = (count: number): 1 | 2 | 3 => {
  if (count >= 3) return 3;
  if (count <= 1) return 1;

  return 2;
};
